import React from 'react';

import { useTheme } from '@material-ui/core/styles';

import MarketingChecklistPage from './MarketingChecklistPage';
import ProjectShell from '@hydra/common/shell/ProjectShell';
import { TaskInterface } from '@hydra/routes/marketing-checklist/components/TaskItem';

interface MarketingChecklistContainerProps {
  data: {
    favicon?: string | null
    tasks: TaskInterface[]
  },
  match: {
    params: {
      url: string
    }
  }
}

export default function MarketingChecklistContainer ({
  data: { tasks, favicon } = { tasks: [], favicon: '' },
  match: { params: { url } }
}: MarketingChecklistContainerProps) {
  const theme = useTheme();

  return (
    <ProjectShell section='marketing-checklist' favicon={favicon || null} bgColor={theme.palette.background.secondary}>
      <MarketingChecklistPage tasks={tasks} url={url} />
    </ProjectShell>
  );
}
